export const DEFAULT_DASHBOARD_SAFETY_POLL_INTERVAL_MS = 60_000

export function resolveDashboardSafetyPollIntervalMs(
  env: Record<string, unknown> = import.meta.env as Record<string, unknown>,
): number {
  try {
    const raw = Number(env.VITE_DASHBOARD_SAFETY_POLL_MS)
    if (Number.isFinite(raw) && raw > 0)
      return raw
    return DEFAULT_DASHBOARD_SAFETY_POLL_INTERVAL_MS
  }
  catch {
    return DEFAULT_DASHBOARD_SAFETY_POLL_INTERVAL_MS
  }
}

export const DASHBOARD_SAFETY_POLL_INTERVAL_MS
  = resolveDashboardSafetyPollIntervalMs()
